class VideoPresentation extends HTMLElement {
    constructor() {
        super()
        var that = this
        var swiperDom_1 = this.querySelector('.indexvideoPresentation')
        var swiperDom_2 = this.querySelector('.indexvideoPresentation2')
        var closeBtn = this.querySelector('.video_mid_cha');
        
        closeBtn.addEventListener('click', this.handleClose.bind(this))


        this.swiper1 = new Swiper(swiperDom_1, {
            loop: true,
            speed: 12000, //匀速时间
            preventClicksPropagation : false,
            slidesPerView: 'auto',
            autoplay: {
                delay: 0,
                stopOnLastSlide: false,
                disableOnInteraction: true
            },
            breakpoints: { 
                280: {
                    slidesPerView: 'auto',
                    spaceBetween: 6,
                },
                769: {  //当屏幕宽度大于等于768 
                  
                    slidesPerView: 'auto',
                    spaceBetween: 16,
                },
                1300: {  //当屏幕宽度大于等于768 
                    slidesPerView: 'auto',
                    spaceBetween: 18,
                }
            }
        });

        if (swiperDom_2.querySelectorAll('.swiper-slide').length > 0) {
            this.swiper2 = new Swiper(swiperDom_2, {
                loop: true,
                speed: 14000, //匀速时间
                slidesPerView: 2,
                // spaceBetween: 30,
                autoplay: {
                    delay: 0,
                    stopOnLastSlide: false,
                    disableOnInteraction: true
                },
                breakpoints: { 
                    280: {  //当屏幕宽度大于等于768 
                        slidesPerView: 'auto',
                        spaceBetween: 6,
                            
                    },
                    769: {  //当屏幕宽度大于等于768 
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    },
                    1300: {  //当屏幕宽度大于等于768 
                        slidesPerView: 'auto',
                        spaceBetween: 16,
                    } 
                },
        
            });
        }

        var videoBtns = this.querySelectorAll('.boxVideo_bottomBox_videoSvg');

        videoBtns.forEach(function(videoBtn) {
            console.log('videoBtn', videoBtn)
            videoBtn.addEventListener('click', that.boxVideoPaly.bind(that, videoBtn))
          })
    }

    boxVideoPaly(e) {
        console.log('VideoPresentation e', e)
        $(".no-focus-outline").addClass("overflowHtml")
        $(".bg-color").show()  
        $(".videos_video_fixed").show();
        this.swiper1.autoplay.stop();
        this.swiper2 && this.swiper2.autoplay.stop();
        var viveoPC = $(e).parent().find(".boxVideo_bottomBox_videoUrl").html();
        // https://www.youtube.com/embed/xjDuYfx6jfU?si=DHoxcpiaauPdnKUB
        if (viveoPC.indexOf("youtube") > -1 && viveoPC.indexOf("embed") === -1) {
            var url = new URL(viveoPC);
            var videoId = url.searchParams.get("v");
            viveoPC = "https://www.youtube.com/embed/" + videoId + "?autoplay=1&rel=0&showinfo=0&modestbranding=1&controls=0&disablekb=1&fs=0&iv_load_policy=3&loop=1&playlist=" + videoId;
        }
        $(".videos_video_fixed").children(".responsive-videos").attr("src",viveoPC.trim())  
    }

    handleClose() {
        $(".bg-color").hide();
        $(".videos_video_fixed").hide();
        $(".no-focus-outline").removeClass("overflowHtml");
        $(".videos_video_fixed").children(".responsive-videos").attr("src", "");

        this.swiper1.autoplay.start();
        this.swiper2 && this.swiper2.autoplay.start();
    }

}

customElements.define('video-presentation', VideoPresentation)